import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';

import { RegistrationFormService } from '../../../services/registration-form.service';

@Component({
  selector: 'app-public-generating-company-registration',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './public-generating-company-registration.component.html',
  styleUrls: ['./public-generating-company-registration.component.scss']
})
export class PublicGeneratingCompanyRegistrationComponent {
  private readonly fb = inject(FormBuilder);
  private readonly formService = inject(RegistrationFormService);
  private readonly router = inject(Router);

  message = '';
  readonly form = this.fb.nonNullable.group({
    company_name: ['', [Validators.required]],
    parent_company: [''],
    registration_type: ['', [Validators.required]],
    cin_registration_no: ['', [Validators.required]],
    installed_capacity_mw: ['', [Validators.required]],
    energy_source: ['', [Validators.required]],
    scada_telemetry_available: ['', [Validators.required]],
    commissioning_date: ['', [Validators.required]],
    address_line1: ['', [Validators.required]],
    address_line2: [''],
    city_town: ['', [Validators.required]],
    district: ['', [Validators.required]],
    state: ['', [Validators.required]],
    pin_code: ['', [Validators.required]],
    country: ['India', [Validators.required]],
    contact_person_name: ['', [Validators.required]],
    designation: [''],
    mobile_number: ['', [Validators.required]],
    email_address: ['', [Validators.required, Validators.email]],
    alternate_mobile: [''],
    alternate_email: [''],
    document_one: [''],
    document_two: [''],
    document_three: [''],
    document_four: [''],
    declaration_accept: [false, [Validators.requiredTrue]]
  });

  readonly documents = [
    'Certificate of Incorporation',
    'PPA / Long-Term Agreement',
    'CEA Registration Certificate',
    'Bank Details (Cancelled Cheque / Letter)'
  ];

  private buildUsername(entityName: string): string {
    const slug = entityName.toLowerCase().replace(/[^a-z0-9]+/g, '.').replace(/^\.+|\.+$/g, '');
    return `${slug || 'gen-com'}-${Date.now().toString(36)}`;
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const raw = this.form.getRawValue();
    const entityName = raw.company_name || 'Generating Company Registration';
    this.formService.submit({
      entity_type: 'GENERATING_COMPANY',
      entity_name: entityName,
      username: this.buildUsername(entityName),
      email: raw.email_address || '',
      mobile: raw.mobile_number || null,
      payload_json: {
        ...raw,
        category: 'GEN_COM',
        documents: this.documents
      },
      documents: []
    }).subscribe({
      next: (response) => {
        this.message = 'Generating company registration submitted successfully.';
        void this.router.navigate(['/register/generating-company/confirmation'], {
          state: {
            registrationNo: response.value === '' ? 'N/A' : response.value.registration_no,
            stakeholderType: 'Generating Company',
            submittedOn: new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            status: 'Pending Admin Review'
          }
        });
      },
      error: () => {
        this.message = 'Unable to submit generating company registration.';
      }
    });
  }
}

